// extracted by mini-css-extract-plugin
export default {"Number":"Number_Number__qE7RY","header":"Number_header__bEm0D","field":"Number_field__awtFv","divRef":"Number_divRef__M+rnj"};